<template>
  <div class="w-full h-full flex flex-col py-2 px-2">
    <div class="relative">
      <Button
        v-if="props.listType === '__removedForNow__filter'"
        type="button"
        variant="text"
        icon="pi pi-folder-open"
        class="text-color !p-0 !absolute top-0 right-0"
        @click="emit('open-filter-dialogue')"
      />
      <h4 class="text-center pb-2 font-bold w-full capitalize">
        {{ props.listType }}
      </h4>
    </div>
    <div
      class="drop-zone w-full p-1 flex-grow"
      @dragover.prevent
      @dragenter.prevent
      @drop="onDrop($event)"
    >
      <div v-if="listType === 'filter'" class="w-full flex flex-col gap-y-2">
        <div
          v-for="(p, popIndex) of queryStore.populations.data"
          :key="popIndex"
        >
          <PopulationPanel v-model="queryStore.populations.data[popIndex]" />
        </div>
      </div>
      <div
        v-if="filteredColList.length === 0"
        class="text-center w-full text-muted-color"
      >
        Drag a column from the table to add it here
      </div>
      <QueryColChip
        v-for="(c, index) of filteredColList"
        :key="index"
        v-model="filteredColList[index]"
        class="chip w-fit cursor-grab"
        draggable="true"
        @dragstart="startDrag($event, c)"
        @dragend="stopDrag"
        @close="queryStore.removeQueryCol(c.uniqueKey)"
      />
    </div>
  </div>
</template>

<script setup>
import QueryColChip from "@/components/information_tabs/query_elements/QueryColChip.vue";
import { computed, defineEmits, defineProps } from "vue";
import { useQueryStore } from "@/stores/queryStore.js";
import Button from "primevue/button";
import PopulationPanel from "@/components/information_tabs/query_elements/PopulationPanel.vue";

const queryStore = useQueryStore();

const emit = defineEmits([
  "start-chip-drag",
  "stop-chip-drag",
  "open-filter-dialogue",
]);
const props = defineProps({ listType: { type: String, default: "keep" } });

const filteredColList = computed(() => {
  return queryStore.queryCols[props.listType];
});

function startDrag(evt, col) {
  emit("start-chip-drag");
  evt.dataTransfer.dropEffect = "move";
  evt.dataTransfer.effectAllowed = "move";
  evt.dataTransfer.setData("colUniqueKey", col.uniqueKey);
  console.debug("begin drag of QueryCol uniqueKey", col.uniqueKey);
  console.debug("begin drag of QueryCol uniqueKey", col.uniqueKey);
}

function stopDrag() {
  emit("stop-chip-drag");
}

function onDrop(evt) {
  let colUniqueKey = evt.dataTransfer.getData("colUniqueKey");
  if (!colUniqueKey) {
    // create new chip
    const colKey = evt.dataTransfer.getData("colKey");
    console.debug(`dropped new col in list ${props.listType}`);
    queryStore.addQueryCol(colKey, props.listType);
    return;
  }
  colUniqueKey = parseInt(colUniqueKey);
  console.debug(`dropped col ${colUniqueKey} in list ${props.listType}`);
  const col = queryStore.queryCols.data.find(
    (col) => col.uniqueKey === colUniqueKey
  );
  col.list = props.listType;
  console.debug("end drag of QueryCol key", colUniqueKey);
}
</script>

<style scoped>
.drop-zone {
  @apply min-h-12 px-1 py-2 flex flex-row gap-x-1 gap-y-2 flex-wrap items-start content-start max-h-full overflow-auto h-full w-full;
  border: 1px dashed transparent;
  border-radius: 8px;
}

.drop-zone[drop-active="true"] {
  border-color: var(--p-primary-200);
}
</style>
